// "Pack my order first" switch in the cart drawer (R49 hidden product, added 19 Oct 2026).
// The drawer leaves a [data-v8pf-set] marker when the line must change by itself:
// 0 = take it off (nothing else in the cart, or it would push the order into free delivery), 1 = back to one.
(() => {
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const sections = ['cart-drawer', 'cart-icon-bubble'];
  const parse = (html, selector) => new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  let busy = false;

  function render(state) {
    const drawer = document.querySelector('cart-drawer');
    drawer.querySelector('.drawer__inner').innerHTML = parse(state.sections['cart-drawer'], '.drawer__inner').innerHTML;
    const fresh = parse(state.sections['cart-drawer'], 'cart-drawer');
    if (fresh) drawer.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble) bubble.innerHTML = parse(state.sections['cart-icon-bubble'], '.shopify-section').innerHTML;
  }

  async function setPack(id, qty) {
    busy = true;
    try {
      const response = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: { [id]: qty }, attributes: { 'Pack first': qty ? 'Yes' : '' }, sections }),
      });
      const state = await response.json();
      if (!response.ok || !state.sections) throw new Error(state.description || 'update failed');
      render(state);
      return true;
    } catch (error) {
      console.error(error);
      return false;
    } finally {
      busy = false;
    }
  }

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-v8pf]');
    if (!button || busy) return;
    event.preventDefault();
    const on = button.getAttribute('aria-checked') !== 'true';
    button.setAttribute('aria-checked', String(on));
    if (!(await setPack(button.dataset.v8pf, on ? 1 : 0))) {
      button.setAttribute('aria-checked', String(!on));
      const errors = document.getElementById('CartDrawer-CartErrors');
      if (errors) errors.textContent = "That didn't change. Please try again.";
    }
  });

  async function check() {
    if (busy) return;
    const marker = document.querySelector('cart-drawer [data-v8pf-set]');
    if (!marker) return;
    marker.remove();
    const ok = await setPack(marker.dataset.v8pfId, Number(marker.dataset.v8pfSet));
    // The cart page draws its own list, so reload it to drop the line there too.
    if (ok && location.pathname === root + 'cart') location.reload();
  }

  function watch() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(check).observe(drawer, { childList: true, subtree: true });
    check();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
